import * as React from "react";

function SvgAdRoll(props, ref) {
  return (
    <svg
      data-name="Layer 1"
      viewBox="0 0 300 300"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M299.5 150c0-74.9-58.82-135.62-135.62-135.62A135.61 135.61 0 0045.44 83.9l66.07 66.1c0-28.9 24.39-52.33 52.32-52.33a52.33 52.33 0 110 104.65H51.14A50.62 50.62 0 00.5 252.93v32.68h163.38A134.77 134.77 0 00299.5 151.69V150"
        fill="#0dbdff"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAdRoll);
